import { useState } from 'react';
import { OfferFormProvider } from '../context';
import { ModalLayout } from './ModalLayout';
import { OfferCreationForm } from './OfferCreationForm';

interface ModalRegisterOfferWrapProps {
  show: boolean;
  confirmOferta: () => void;
  closeOferta: () => void;
  id: string;
  idsLojas: string[];
  blocosOfertas: { label: string; value: string | number }[];
  setOferta: (data: any) => void;
  editOferta: boolean;
  ofertaId?: string | null;
  initialProducts?: any[];
  initialOffer?: Record<string, any> | null;
  initialOfferGroup?: string | null;
}

export const ModalRegisterOfferWrap = ({
  show,
  confirmOferta,
  closeOferta,
  id,
  idsLojas,
  blocosOfertas,
  setOferta,
  editOferta,
  ofertaId,
  initialProducts,
  initialOffer,
  initialOfferGroup,
}: ModalRegisterOfferWrapProps) => {
  const [isFormValid, setIsFormValid] = useState(false);

  return (
    <ModalLayout
      show={show}
      onConfirm={confirmOferta}
      onCancel={closeOferta}
      title={!editOferta ? 'Adicionar oferta' : 'Editar oferta'}
      confirmButton={!editOferta ? 'Salvar oferta' : 'Alterar oferta'}
      confirmDisabled={!isFormValid}
      cancelButton="fechar"
      width="900px"
      height="782px"
    >
      <OfferFormProvider key={String(show)}>
        <OfferCreationForm
          id={id}
          idsLojas={idsLojas}
          blocosOfertas={blocosOfertas}
          setOferta={setOferta}
          editOferta={editOferta}
          ofertaId={ofertaId ?? undefined}
          show={show}
          initialProducts={initialProducts}
          onValidityChange={setIsFormValid}
          initialOffer={initialOffer as any}
          initialOfferGroup={initialOfferGroup}
        />
      </OfferFormProvider>
    </ModalLayout>
  );
};
